<mat-drawer-container>
    <mat-drawer #drawer position="end">
        <app-table-config-form [columns]="TableColumnsSorted$ | async" [selectedColumns]="selectedColumns$ | async"  (selectedColumnsChange)="selectedColumnsChange($event)"></app-table-config-form>
    </mat-drawer>
<section #wrapperElement class="wrapper">
<mat-card class="mat-card" >
    <div class="card-headline box-shadow-top">
        <h3 mat-dialog-title *ngIf="!DialogData.FilterValues" >{{ DialogData.Headline }}</h3>
        <h3 mat-dialog-title *ngIf="DialogData.FilterValues" >{{(BvFilterValues$ | async).type === BusinessVolumeCostStateEnum.Costs ? 'Kosten (Netto)' : 'Umsätze (Netto)'}}</h3>
        <div class="header-button-wrapper">
            <mat-form-field floatLabel="never"  [style.visibility]="searchVisible ? 'visible' : 'hidden'" (click)="$event.stopPropagation()" style="width: 16rem">
                <mat-label>Suche</mat-label>
                <input matInput type="search" [formControl]="searchForm" #searchInput   />
                <button class="clear-search" *ngIf="searchForm.value" mat-icon-button aria-label="Clear" (click)="searchForm.setValue('')">
                </button>
            </mat-form-field>
            <button style="margin: auto 0 auto auto"  app-round-button (click)="$event.stopPropagation(); toggleSearch()" [matTooltip]="searchVisible ? 'abbrechen' : 'suchen'">
                <fa-icon [icon]="searchVisible ? 'times' : 'search'"></fa-icon>
            </button>
            <button style="margin: auto 0 auto auto" app-round-button matTooltip="Umsatz hinzufügen" (click)="addBV(); $event.stopPropagation();" *ngIf="canCreateBV$ | async"><fa-icon icon="plus"></fa-icon></button>
            <div style="margin: auto 0 auto auto" *ngIf="!Multiselect">
                <button  app-round-button Inverted [Disabled]="(dataSource.length$ | async) === 0"
                        matTooltip="Mehrfachauswahl" (click)="ToggleMultiselect()">
                    <fa-icon icon="check-square"></fa-icon>
                </button>
            </div>
            <div style="margin: auto 0 auto auto" *ngIf="Multiselect">
                <button  app-round-button Inverted matTooltip="Abbrechen" (click)="ToggleMultiselect()">
                    <fa-icon icon="times"></fa-icon>
                </button>
            </div>
            <button style="margin: auto 0 auto auto" app-round-button [Disabled]="Multiselect"
                    (click)="bVFilter.Toggle(); $event.stopPropagation();"
                    [matBadge]="FilterAmount$ | async"
                    [matBadgeHidden]="!(FilterAmount$ | async)"
                    matTooltip="Filter"
                    [matBadgeOverlap]="true"
                    class="mat-badge-more-overlay"
            >
                <fa-icon icon="filter"></fa-icon>
            </button>
            <button style="margin: auto 0 auto auto" class="header-button" app-round-button [matBadge]="disabledColumns$ | async" matTooltip="Tabelle anpassen" matTooltipPosition="left" (click)="drawer.toggle()">
                <fa-icon icon="cog"></fa-icon>
            </button>


        </div>
    </div>
        <div class="table-wrapper">
            <table mat-table class="full-width-table fixed-header" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" matSort>
                <ng-container *ngFor="let column of TableColumns$ | async" [matColumnDef]="column.name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header cdkDrag class="drag-header" cdkDragBoundary=".mat-header-row" [cdkDragPreviewContainer]="wrapperElement" cdkDragPreviewClass="mat-elevation-z2">
                        {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <ng-container [ngSwitch]="column.name">
                            <ng-container *ngSwitchCase="'status'">
                                <fa-icon *ngIf="row.checked" icon="check-circle" style="color: #03a468"></fa-icon>
                                {{ row[column.name] }}
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                {{ row[column.name] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="select">
                    <th mat-header-cell  *matHeaderCellDef style="padding: 0 1rem; margin: 5rem">
                        <mat-checkbox (change)="toggleAllSelections()" [checked]="allSelected$ | async"
                                      [indeterminate]="(SelectedBvs$ | async)?.length > 0 && !(allSelected$ | async)">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" style="width: 2rem">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="CheckBoxSelectBv($event, row)"
                                      [checked]="IsSelected(row)"
                                      [class.selected]="selection.isSelected(row)"
                        >
                        </mat-checkbox>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="availableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: availableColumns;" (click)="openEditDialog(row)"
                    [class.selected]="IsSelected(row)"
                    [class.app-color-late]="!validSettlementDate(row)"
                    class="clickable-mat-row"
                    ></tr>
            </table>
            <ng-container></ng-container>
            <app-loading *ngIf="dataSource.loading$ | async"></app-loading>
            <table *ngIf="((dataSource.loading$ | async) === false) && ((dataSource.length$ | async) === 0)" style="width: 100% ; text-align: center">
                <h2>
                    Keine Datensätze in diesem Zeitraum vorhanden
                </h2>
            </table>
        </div>
    <app-mat-paginator-wrapper class="flex ml-auto">
        <mat-paginator [pageSize]="100" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Seite wählen"> </mat-paginator>
    </app-mat-paginator-wrapper>
        <div class="box-shadow-bottom">
            <mat-dialog-actions class="footer">
                <button app-button mat-dialog-close Inverted Color="cancel">Abbrechen</button>
                <div style="display: flex; gap: 0.5rem">
                    <button app-button (click)="export()" [Disabled]="(SelectedBvs$|async)?.length === 0"
                            [IsLoading]="ls.IsLoading$ | async">auswahl Exportieren
                    </button>
                    <button app-button *ngIf="!Multiselect" [Disabled]="(dataSource.length$ | async) === 0" (click)="exportAll()">Alle Exportieren</button>
                </div>
            </mat-dialog-actions>
        </div>
</mat-card>
</section>
<app-filter-card UnlimitedHeight #bVFilter [Settings]="BvFilterSettings | async" [LargeCard]="true"
                 [Values]="BvFilterValues$ | async" (ValuesChange)="BvFilterValues$.next($event)"></app-filter-card>
</mat-drawer-container>

